import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { API_URL } from "../../../utils/constant";
import axios from "axios";

export const getCourseMetaSliceContent = createAsyncThunk('/courseMetas/content', async () => {
	const response = await axios.post(`${API_URL}/getCourseMetaData`);
    console.log(response.data);
	return response;
})

export const courseMetaSlice = createSlice({
    name: 'courseMetas',
    initialState: {
        isLoading: false,
        courseMetas : []
    },
    reducers: {
    },
    extraReducers: {
		[getCourseMetaSliceContent.pending]: state => {
			state.isLoading = true
		},
		[getCourseMetaSliceContent.fulfilled]: (state, action) => {
			state.courseMetas = action.payload.data
			state.isLoading = false
		},
		[getCourseMetaSliceContent.rejected]: state => {
			state.isLoading = false
		},
    }
})

export default courseMetaSlice.reducer